(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-related-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    root.querySelectorAll('[data-bc-related]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const load = async () => {
        try {
          const response = await fetch(section.dataset.url);
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const grid = html.querySelector('[data-bc-related-grid]');
          if (!grid) return;
          grid.querySelectorAll('[data-bc-product-id]').forEach(card => {
            if (card.dataset.bcProductId === section.dataset.currentProduct) card.remove();
          });
          if (grid.children.length) section.querySelector('[data-bc-related-grid]').replaceChildren(...grid.children);
        } catch (_) { /* Server-rendered collection fallback remains usable. */ }
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
        }, { rootMargin: '400px' });
        observer.observe(section);
      } else load();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
